export default "__VITE_ASSET__BswN4rFK__"